import React from 'react';
import PropTypes from 'prop-types';

import star from '../images/icons/star.svg';

import './RatingBadge.less';
import {cn} from 'spa/css';
import withI18n from 'spa/Components/Context/withI18n';

@withI18n
class RatingBadge extends React.Component {
  static propTypes = {
    rating: PropTypes.number.isRequired,
    padded: PropTypes.bool,
    noFloat: PropTypes.bool,
    small: PropTypes.bool,
  };

  render() {
    const {i18n} = this.context;
    const {
      noFloat, padded, rating, small,
    } = this.props;

    if (isNaN(rating)) return null;
    const defaultClass = 'RatingBadge';
    const classNames = padded ? `${defaultClass} ${defaultClass}--padded` : defaultClass;

    return (
      <div
        className={cn(
          classNames,
          noFloat ? '' : `${defaultClass}--float`,
          small ? `${defaultClass}--small` : '',
        )}>
        <img
          src={star}
          alt={`${i18n._x('star(s)', 'Rating alt text')}: ${rating}`}
          className={cn(
            'RatingBadge-star',
            small ? `${defaultClass}-star--small` : '',
          )} />
        {rating}
      </div>
    );
  }
}

export default RatingBadge;



// WEBPACK FOOTER //
// ./spa/Components/RatingBadge.jsx